export default __webpack_public_path__ + "static/media/client-07.64c3c644.svg";